<template lang="">
  <ion-card @click="goMatch(match._id)" class="custom-card">
    <ion-card-content>
      <section class="overview d-flex justify-between mb-1">
        <div class="mb-1">
          <span class="c-yellow f-bold">{{
            match?.round?.displayName ||
            (match?.round?.type === "Final"
              ? match?.round?.number === 1
                ? "Semi Final"
                : "Final"
              : "Round " + (match?.round?.name || match?.round?.number))
          }}</span>
          <h5 class="c-white bold-title date-time">
            {{ moment(dateTime).format("LLL") }}
          </h5>
          <span class="c-gray"
            >{{ get(venue, "name", "TBA") }} {{ get(meta, "field.name") }}</span
          >
        </div>
        <div class="status">
          <ion-badge
            v-if="match.currentSetId && status === 'sets'"
            color="light"
            class="gap-05 in-progress-box text-center flex align-center p-10"
          >
            <div class="dot"></div>
            <p>Set {{ match.currentSetId }}</p>
          </ion-badge>
          <ion-badge
            v-else-if="status === 'first-half' || status === 'second-half'"
            :color="gameStatusColor(status)"
            class="
              mb-05
              gap-05
              in-progress-box
              text-center
              flex
              align-center
              p-10
            "
          >
            <div class="dot"></div>
            <p>
              {{
                upperCase(status)
                  .replace("FIRST", "1st")
                  .replace("SECOND", "2nd")
                  .replace("PENALTY", "Penalties")
              }}
            </p>
          </ion-badge>
          <ion-badge
            v-else
            :color="gameStatusColor(status)"
            class="mb-05 text-center flex align-center p-10"
          >
            <ion-icon
              v-if="checkForfeit('homeTeam', status, meta, homeTeam)"
              :icon="arrowBackOutline"
            >
            </ion-icon
            >{{ upperCase(status)
            }}<ion-icon
              v-if="checkForfeit('awayTeam', status, meta, awayTeam)"
              :icon="arrowForwardOutline"
            >
            </ion-icon>
          </ion-badge>
        </div>
      </section>
      <div class="d-flex flex-column gap-025">
        <div class="d-flex justify-between align-center gap-10">
          <div class="d-flex gap-10 align-center">
            <TeamLogo
              :team="homeTeam"
              :small="true"
              :competition="competition"
            />
            <div class="bold-title team-name mt-10">
              {{ get(homeTeam, "name", meta && !!meta.isBye ? "BYE" : "TBA") }}
            </div>
          </div>
          <div class="c-white bold-title score-text">
            {{
              getScore(
                "homeTeam",
                scoringEvents,
                scores,
                status,
                meta,
                homeTeam,
                competitionId
              )
            }}
          </div>
        </div>
        <div class="d-flex justify-between align-center gap-10">
          <div class="d-flex gap-10 align-center">
            <TeamLogo
              :team="awayTeam"
              :small="true"
              :competition="competition"
            />
            <div class="bold-title team-name mt-10">
              {{ get(awayTeam, "name", meta && !!meta.isBye ? "BYE" : "TBA") }}
            </div>
          </div>
          <div class="c-white bold-title score-text">
            {{
              getScore(
                "awayTeam",
                scoringEvents,
                scores,
                status,
                meta,
                awayTeam,
                competitionId
              )
            }}
          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import TeamLogo from "../views/matches/base/team-logo.vue";

export default {
  name: "MatchCard",
  props: {
    match: {
      type: Object,
      required: true,
    },
    competition: {
      type: Object,
      required: true,
    },
    competitionId: {
      type: Number,
      required: true,
    },
  },
  components: { TeamLogo },
  data() {
    return {
      moment,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      compeititonId: this.match?.competition?._id,
      venue: this.match.venue,
      meta: this.match.meta,
      scores: this.match.scores,
      scoringEvents: this.match.scoringEvents,
      weather: this.match.weather,
      homeTeam: this.match.homeTeam,
      awayTeam: this.match.awayTeam,
      dateTime: this.match.dateTime,
      status: this.match.status,
    };
  },
  computed: {
    entity() {
      return this.$store.getters["national/getEntity"];
    },
  },
  methods: {
    checkForfeit(type, status, meta, team) {
      if (type === "homeTeam") {
        if (status === "forfeit") {
          const isForfeitingTeam =
            _.get(meta, "forfeitingTeam.name") === _.get(team, "name");
          return isForfeitingTeam ? true : false;
        }
        return false;
      } else if (type === "awayTeam") {
        if (status === "forfeit") {
          const isForfeitingTeam =
            _.get(meta, "forfeitingTeam.name") === _.get(team, "name");
          return isForfeitingTeam ? true : false;
        }
        return false;
      }
    },
    getScore(type, scoringEvents, scores, status, meta, team, competitionId) {
      const hasPenaltyPeriod = scoringEvents
        ? scoringEvents.some(
          (ev) =>
              ev?.name?.toLowerCase()?.includes("penalty") &&
              ev?.period === 9999
        )
        : false;
      if (type === "homeTeam" || type === "awayTeam") {
        // if (status === 'forfeit') {
        //   // const isForfeitingTeam = _.get(meta, 'forfeitingTeam.name') === _.get(team, 'name');
        //   // const competition = _.find(this.competitions, { _id: competitionId });
        //   // return isForfeitingTeam ? 0 : _.get(competition, 'laddertemplate.defaultScoreFFReceived');
        //   // Commented out old code, the this.competitions is not defined in this component
        //   const score = type === 'homeTeam' ? _.get(scores, 'homeTeam', 0) : _.get(scores, 'awayTeam', 0);
        //   return score;
        // }
        if (status === "penalty" || hasPenaltyPeriod) {
          const mainScore = _.get(scores, `${type}`, 0);
          const penScoreEvents = scoringEvents.filter(
            (ev) =>
              ev?.name?.toLowerCase()?.includes("penalty") &&
              !ev?.name?.toLowerCase()?.includes("miss") &&
              ev?.teamId === team?._id
          );
          const penScore = penScoreEvents.reduce((acc, cur) => acc + 1, 0);
          const penScoreValues = penScoreEvents.reduce(
            (acc, cur) => acc + cur.value,
            0
          );
          return type === "homeTeam"
            ? `${mainScore - penScoreValues} (${penScore}) `
            : `${mainScore - penScoreValues} (${penScore})`;
        }
        return _.get(scores, `${type}`, 0);
      }
    },
    getHomeScore(scores, status, meta, homeTeam, competitionId) {
      if (status === "forfeit") {
        const competition = _.find(this.competitions, { _id: competitionId });
        const isForfeitingTeam =
          _.get(meta, "forfeitingTeam.name") === _.get(homeTeam, "name");
        return isForfeitingTeam
          ? 0
          : _.get(competition, "laddertemplate.defaultScoreFFReceived");
      } else {
        return _.get(scores, "homeTeam", 0);
      }
    },
    getAwayScore(scores, status, meta, awayTeam, competitionId) {
      if (status === "forfeit") {
        const competition = _.find(this.competitions, { _id: competitionId });
        const isForfeitingTeam =
          _.get(meta, "forfeitingTeam.name") === _.get(awayTeam, "name");
        return isForfeitingTeam
          ? 0
          : _.get(competition, "laddertemplate.defaultScoreFFReceived");
      } else {
        return _.get(scores, "awayTeam", 0);
      }
    },
    isLastIndex(round, index) {
      const nextIndex = index + 1;
      if (!this.filteredMatches[nextIndex]) return true;
      return round.number !== this.filteredMatches[nextIndex].round.number;
    },
    getByes(round) {
      const res = _.filter(this.byes, (g) => g.round.number === round.number);
      return res;
    },
    // getWeatherIcon(name) {
    //   var images = require.context('../assets/weather-icons/', false, /\.svg$/)
    //   return images('./' + name + ".svg")
    // },
    goMatch(id) {
      if (this.entity && this.entity?.level && this.entity?.name) {
        this.$router.push(
          `/c/${this.entity?.level}/${this.entity?.name}/matches/${id}`
        );
        return;
      }
      this.$router.push(`/matches/${id}`);
    },
    goToAS() {
      window.open("https://assemblesports.com", "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand = Math.random();
      return rand <= freq / 100;
    },
    segmentChanged(event) {
      this.segment = event.detail.value;
      if (this.segment === "matches") {
        this.ladderSegment = "ladderBoard";
      } else {
        this.ladderSegment = "ladderBoard";
      }
    },
    ladderSegmentChanged(event) {
      this.ladderSegment = event.detail.value;
    },
    setSegment() {
      if (this.filteredMatches.length > 0) this.segment = "matches";
      else if (Object.keys(this.ladder).length > 0) this.segment = "ladder";
      else this.segment = "matches";
    },
    gameStatusColor(status) {
      switch (status) {
      case "pre-game":
        return "light";
      case "final":
        return "success";
      case "forfeit":
      case "washout":
        return "warning";
      case "disputed":
      case "offline":
        return "danger";
      case "first-half":
      case "second-half":
        return "light";
      default:
        return "light";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bold-title {
  max-width: none;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.custom-card {
  border-radius: 16px;
  cursor: pointer;
  font-family: "BrownStd-Regular", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  color: white;

  // Enhanced gradient background with glassmorphism - more subtle
  background: linear-gradient(
    135deg,
    rgba(25, 26, 29, 0.9) 0%,
    rgba(30, 31, 34, 0.95) 50%,
    rgba(25, 26, 29, 0.9) 100%
  ) !important;

  // Subtle border matching selection-container style
  border: 1px solid rgba(255, 255, 255, 0.08);

  // More subtle shadow to match selection container
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2), 0 1px 4px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  margin-inline: 1rem;
  margin-bottom: 0.75rem;
  padding: 0;

  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.12);

    background: linear-gradient(
      135deg,
      rgba(30, 31, 34, 0.95) 0%,
      rgba(35, 37, 40, 1) 50%,
      rgba(30, 31, 34, 0.95) 100%
    ) !important;

    border-color: rgba(255, 255, 255, 0.12);
  }

  &:active {
    transform: translateY(0px);
  }

  ion-card-content {
    padding: 16px !important;
  }
}

// Enhanced overview section - more compact
.overview {
  margin-bottom: 1rem !important;

  .c-yellow {
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    font-size: 0.8rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    text-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
  }

  .date-time {
    font-size: 1rem;
    font-weight: 600;
    color: #f8f9fa;
    margin: 0.5rem 0 0.3rem 0;
    letter-spacing: -0.02em;
    line-height: 1.3;
  }

  .c-gray {
    color: #a0a0a0;
    font-size: 0.85rem;
    font-weight: 400;
    letter-spacing: 0.01em;
    opacity: 0.9;
  }
}

// Enhanced status badges - more compact
ion-badge {
  border-radius: 10px;
  height: auto;
  min-height: 1.6rem;
  padding: 0.3rem 0.6rem;
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;

  // Glassmorphism effect for badges
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);

  &.in-progress-box {
    background: linear-gradient(
      135deg,
      rgba(76, 175, 80, 0.9),
      rgba(129, 199, 132, 0.9)
    ) !important;
    color: white !important;
    box-shadow: 0 3px 8px rgba(76, 175, 80, 0.3);
  }

  .dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    margin-right: 0.3rem;
    animation: pulse 2s infinite;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

// Enhanced team section - more compact
.d-flex.flex-column.gap-025 {
  gap: 0.6rem;

  .d-flex.justify-between.align-center {
    padding: 0.25rem 0;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.02);
    }
  }
}

.team-name {
  font-family: "BrownStd-Regular", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #f5f5f5;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin-top: 0.1rem !important;

  // Subtle text shadow for better readability
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.score-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.02em;
  min-width: 2.2rem;
  text-align: right;
}

// Enhanced team logo container
.d-flex.gap-10.align-center {
  align-items: center;
  flex: 1;
  min-width: 0; // Prevents flex overflow

  team-logo {
    flex-shrink: 0;
  }
}

// Responsive typography
@media (max-width: 768px) {
  .custom-card {
    margin-inline: 0.75rem;
    margin-bottom: 0.6rem;

    ion-card-content {
      padding: 14px !important;
    }
  }

  .overview {
    margin-bottom: 0.8rem !important;
  }

  .team-name {
    font-size: 0.9rem;
  }

  .score-text {
    font-size: 1.35rem;
  }

  .date-time {
    font-size: 0.95rem;
  }

  .c-yellow {
    font-size: 0.75rem !important;
  }

  .c-gray {
    font-size: 0.8rem !important;
  }
}

// Legacy styles cleanup
.custom-card .card-content-ios {
  padding: 16px !important;
}

.custom-card .promoted-header {
  font-family: "BrownStd-Regular";
  text-align: center;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 1.4;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios,
.list-md {
  padding: 0;
  background: transparent;
}
</style>
